import React from 'react';
import {
  DropdownMenuCheckboxItem,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';
import {
  ACTION_COLUMN_LABELS,
  REQUIRED_ACTION_COLUMNS,
  actionColumnsForScope,
  type ActionColumnId,
} from './actionColumnModel';
import type { IapScope } from '../ICSConstants';
import { useAorText } from 'utils/aorTerminology';

type ActionColumnMenuItemsProps = {
  scope: IapScope;
  hidden: readonly string[];
  onToggle: (id: ActionColumnId) => void;
  onReset: () => void;
};

/** Checkbox items for choosing Actions-table columns. */
export const ActionColumnMenuItems: React.FC<ActionColumnMenuItemsProps> = ({
  scope,
  hidden,
  onToggle,
  onReset,
}) => {
  const aorText = useAorText();
  const columns = actionColumnsForScope(scope);

  return (
    <>
      {columns.map((id) => {
        const required = REQUIRED_ACTION_COLUMNS.includes(id);
        return (
          <DropdownMenuCheckboxItem
            key={id}
            checked={!hidden.includes(id)}
            disabled={required}
            title={required ? 'Always shown' : undefined}
            onCheckedChange={() => {
              if (!required) onToggle(id);
            }}
          >
            {aorText(ACTION_COLUMN_LABELS[id])}
          </DropdownMenuCheckboxItem>
        );
      })}
      <DropdownMenuSeparator />
      <DropdownMenuItem onClick={onReset}>Reset to default</DropdownMenuItem>
    </>
  );
};
